import { render, staticRenderFns } from "./newRegister.vue?vue&type=template&id=f0150354&"
import script from "./newRegister.js?vue&type=script&lang=js&"
export * from "./newRegister.js?vue&type=script&lang=js&"
import style0 from "./newRegister.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports